import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=c112baac&"
import script from "./Pricing.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pricing.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports